import { ParameterHandler } from '../ParameterHandler';
import { createMasterChannelParameterSelector, selectSampleRate, setMasterChannelParameter } from '../store';
import { MasterChannel } from '../channels/MasterChannel';
import { staticSelect } from './react';
import { widgetLegends } from "../widgetLegends";

export const getMasterChannelParameterHandler = parameterName => {
    return new ParameterHandler(MasterChannel.parametersDescription[parameterName], createMasterChannelParameterSelector(parameterName), value => setMasterChannelParameter({name: parameterName, value}))
}

export const getInitialParamValues = parametersDescription => {
    return Object.fromEntries([...Object.entries(parametersDescription)].map(([name, {initial}]) => [name, initial]));
}

export const limitToNyquist = frequency => {
    const sr = staticSelect(selectSampleRate);
    return Math.min(frequency, sr/2);
}

export const getWidgetData = (widgetID) => {
    if (widgetID == null) console.warn("No widget ID for this knob!")
    let widgetData;
    if (widgetID) {
        widgetData = widgetLegends[widgetID];
        if (widgetData == null) console.warn(`No widget data for widgetID ${widgetID}`)
    }
    return widgetData;
}